/**
 * Created by Rodrigo Quesada on 30/03/17.
 */
import {PersonalInfo as PersonalInfoModel} from '../model/cv.model';
import {formatOrEmpty, separatedBy, separatedBySpace} from '../../../shared/utils';

export class PersonalInfo {

    readonly name?: string;
    readonly address1?: string;
    readonly address2?: string;
    readonly cellPhoneNumber?: string;
    readonly homePhoneNumber?: string;
    readonly faxNumber?: string;
    readonly email?: string;

    constructor(personalInfo: PersonalInfoModel) {
        const userInfo = personalInfo.userInfo;
        const name = userInfo.name;

        this.name = separatedBy(', ', separatedBySpace(name.firstName, formatOrEmpty(name.middleName, it => `${it.charAt(0)}.`), name.lastName), 'MD');

        const address = personalInfo.address;
        if (address) {
            this.address1 = address.address1;
            this.address2 = separatedBySpace(separatedBy(', ', address.city, address.stateOrProvince), address.postalCode);
        }

        const contactInfo = personalInfo.contactInfo;
        if (contactInfo) {
            this.cellPhoneNumber = contactInfo.phoneNumbers.mobile;
            this.homePhoneNumber = contactInfo.phoneNumbers.home;
            this.faxNumber = contactInfo.phoneNumbers.fax;
        }

        this.email = userInfo.email1;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/cv/download/document/personal-info.class.ts